const formSelectStyles = {
    container: (styles: any, { isDisabled }: any) => ({
        ...styles,
        cursor: isDisabled ? 'not-allowed' : 'default',
        fontSize: "13px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "16px",
        letterSpacing: "-0.078p",
    }),
    singleValue: (styles: any) => ({
        ...styles,
        color: '#000',
        fontSize: "13px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "16px",
        letterSpacing: "-0.078p",
    }),
    indicatorSeparator: (styles: any) => ({ display: 'none' }),
    control: (styles: any) => ({
        ...styles,
        borderRadius: '5px',
        borderColor: '#E2E8F0',
        backgroundColor: '#FFFFFF',
        padding: "1.5px",
        border: '1px solid dark_grey',
    }),
    option: (styles: any, { isFocused }: any) => ({
        ...styles,
        cursor: 'pointer',
        textAlign: 'left',
        fontSize: "13px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "16px",
        letterSpacing: "-0.078p",
        color: '#000',
        backgroundColor: isFocused ? '#CCC' : '#FFF',
    }),
    placeholder: (styles: any) => ({
        ...styles,
        color: "#8C909C",
        fontSize: "13px",
        fontWeight: "500",
        lineHeight: "16px",
        letterSpacing: "-0.078px",
    }),
};

export { formSelectStyles };